export default "__VITE_ASSET__DW1Mq9IS__"